export default __webpack_public_path__ + "static/media/005-banker.80d4c719.svg";